var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 50,
    height: 20,
    rx: 10,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 25,
    r: 10,
    fill: "#8a76db"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleWidget);
export default __webpack_public_path__ + "static/media/toggle-widget.f548b03718a7eb0c469342e77017e6e3.svg";
export { ForwardRef as ReactComponent };